import { useFeatureFlag } from '@fs/zion-flags'
import { useUser } from '@fs/zion-user'
import { FLAGS } from '../../../../config/feature/flags'

// The discovery_prototypes rollout gate. In STATION it picks the shared
// controls over the legacy StationMenu as the kiosk chrome
// (useKioskNavigationPolicy); in WEB it shows the Home action
// (useExperienceNavVisibility) and lets the live production experiences hand
// their Home and Back to the controls (useLegacyNavHomePath and their gated
// Back registrations) - before it they show none of the new controls.
export function useExperienceNavControlsRolloutEnabled() {
  const { isOn } = useFeatureFlag(FLAGS.PROTOTYPES)

  return isOn
}

// Live production experiences retain their signed-in + rollout gate for both
// Home destinations and any legacy controls that shared navigation replaces.
export function useLegacyExperienceNavControlsEnabled() {
  const { signedIn } = useUser()
  const rolloutEnabled = useExperienceNavControlsRolloutEnabled()

  return signedIn && rolloutEnabled
}
